import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export type StoreButtonBoxSkeletonProps = {}

export const StoreButtonBoxSkeleton: FC<StoreButtonBoxSkeletonProps> = ({}) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{ minHeight: 76 }}
  >
    <Stack flex={1} spacing={1}>
      <SkeletonText variant="medium" width="50%" />
      <SkeletonText variant="small" width="25%" />
    </Stack>
    <Stack>
      <Skeleton
        variant="rectangular"
        width={160}
        height={38}
        sx={{ borderRadius: '2px' }}
      />
    </Stack>
  </Stack>
)
